import { EThemeNames } from '@/constants';
import { EBotNames } from './botNames';
import WarningIcon from '@/icons/WarningIcon';
import { EEventTypes } from '@/types';
import { EBotNamesBackend } from '@/types/botConfigTypes';

export const botConfigs = {
  [EBotNames.TELEHEALTH_TRIAGE]: {
    homeScreen: {
      title: 'Hello {placeholder}',
      subtitle: "Let's find you a doctor",
      inputPlaceholder: 'Tell us the symptoms',
    },
    warning: {
      text: 'Whatever you share, stays here. Your privacy is in good hands.',
      icon: WarningIcon,
    },
    useCases: [
      {
        title: 'Find the support you need',
        info: 'A few gentle questions will help us understand your current state and match you with a therapist who can walk alongside you.',
        themeName: EThemeNames.MATCH_THERAPIST_DEFAULT,
        additionalInfo: {
          text: 'Whatever you share, stays here. Your privacy is in good hands.',
          icon: WarningIcon,
          type: EEventTypes.INFO,
        },
      },
    ],
    finalFeedbackText: 'Thanks for your feedback',
    botName: EBotNamesBackend.SPECIALITY_MATCH,
    themeName: EThemeNames.TELEHEALTH_TRIAGE_BOT,
  },
};
